import type { PageContext } from "vike/types";

import { TITLE } from "../../renderer/constants.js";
import type { PostData } from "./+data.js";

const title = (pageContext: PageContext) => {
  const data = pageContext.data as PostData | undefined;
  return data?.meta?.title ? `${data.meta.title} | ${TITLE}` : TITLE;
};

export default title;
